<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control campos" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id" >{{tipo.Nombre}} un estatus</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los estatus</option>
        <option v-for="Estatus in EstatusDeDictamen" :value="Estatus.EstatusDictamenId" :key="Estatus.EstatusDictamenId">{{Estatus.Nombre}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        EstatusDeDictamen: [],
        idDelModelo: null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object,
      deshabilitado: false
    },
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }

      //this.$store.dispatch("A_SIPSIC_Catalogo_Establecer04EstatusDeDictamen", parametros);
    },
    methods: {
      cargaCatalogoEstatusDeDictamen() {
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba

        axios.post(api.conexion + api.SIPSIC.catalogos.C004EstatusDeDictamen, this.parametros)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.EstatusDeDictamen = respuesta.data.EstatusDeDictamen;

              if (this.parametros.filtros != undefined && this.parametros.filtros != null) {
                this.EstatusDeDictamen = respuesta.data.EstatusDeDictamen.filter(cond => this.parametros.filtros.some(estatus => estatus == cond.EstatusDictamenId));
              }
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        this.$store.dispatch("A_SIPSIC_Catalogo_Establecer004EstatusDeDictamen", parametros);
        this.$emit("valorParaElPadre", [evento, this.EstatusDeDictamen[evento.target.selectedIndex - 1]]);

        //evento.target[evento.target.selectedIndex].label esto sirve para obtener el label de valor actual
      }
    },
    created() {
      this.cargaCatalogoEstatusDeDictamen();
    }
  }
</script>

<style>
 .campos{
  background-color: white;
  color: black;
  }
</style>



// WEBPACK FOOTER //
// src/components/SIPSIC/Comun/Catalogos/004EstatusDeDictamen.vue